jsonpFunctionUIB([5],{

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        var trackGTMEvents = function(options, callback){
	            
	            var dataLayerName = options.dataLayerName || 'dataLayer';
	            var eventPrefix = options.datapointPrefix || '';
	            if (eventPrefix!='') eventPrefix = eventPrefix+".";
	            var ignoreEventsArr = options.ignoreEvents || [];
	            var trackEventsArr = options.trackEvents || [];
	            var ignoreEventsLength = ignoreEventsArr.length;
	            var trackEventsLength = trackEventsArr.length;
	            var defaultTracking = trackEventsLength === 0;
	            
	            var matchRuleShort = function (str, rule) {
	                return new RegExp("^" + rule.replace(/[.?+^$[\]\\(){}|-]/g, "\\$&").split("*").join(".*") + "$").test(str);
	            }
	            var trackEvents = function (i){
	                while (i<dl.length) {
	                    var track = defaultTracking;
	                    var matched = false;
	                    if (dl[i].event){
	                        for (var j=0; j<ignoreEventsLength; j++){
	                            if (matchRuleShort(dl[i].event,ignoreEventsArr[j])){
	                                track = false;
	                                break;
	                            }
	                        }
	                        if (!matched){
	                            for (var j=0; j<trackEventsLength; j++){
	                                if (matchRuleShort(dl[i].event,trackEventsArr[j])){
	                                    track = true;
	                                    break;
	                                }
	                            }
	                        }
	                    
	                        if (track){
	                            var o = {};
	                            for (var key in dl[i]){
	                                if (key.indexOf('gtm.')!==0 && key !== 'event'){
	                                    if (typeof dl[i][key] !== 'object'){
	                                        o[key] = dl[i][key];
	                                    }
	                                }
	                            }
	                            uDash.saveMeta(eventPrefix+dl[i].event,JSON.stringify(o));
	                        }
	                    }
	                    i++;
	                }
	                setTimeout(trackEvents, 100, i);
	            }
	
	            var dl = window[dataLayerName];
	            if (dl && typeof dl !=='undefined'){                
	                trackEvents(0);      
	                callback(null);
	            }else{
	                callback(new Error("No GTM window."+dataLayerName+" found. Consider adding it to the response dependencies."));
	            }
	        }
	        return trackGTMEvents;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })

});


// WEBPACK FOOTER //
// responses/data-collection/trackGTMEvents/trackGTMEvents.js